import { useTranslation } from 'react-i18next';
import { CAPACITY_HOURS_DISPLAY_DECIMALS } from '../../../constants/capacityConstants';
import { roundToDecimals } from '../../../utils/numberUtils';
import { DistributionBarRow } from './DistributionBarRow';
import { DistributionLegend } from './DistributionLegend';
import type { ProfessionHours } from './types';
import styles from './KpiDistributionPopover.module.css';

interface TimeDistributionPopoverProps {
  professions: readonly ProfessionHours[];
}

const roundHours = (hours: number): number =>
  roundToDecimals(hours, CAPACITY_HOURS_DISPLAY_DECIMALS);

export const TimeDistributionPopover = ({ professions }: TimeDistributionPopoverProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.popover}>
      <div className={styles.title}>{t('gantt-time-distribution-title')}</div>
      <div className={styles.grid}>
        {professions.map((entry) => (
          <DistributionBarRow
            key={entry.profession.id}
            name={entry.profession.name}
            planned={entry.planned}
            threshold={entry.threshold}
            plannedLabel={t('gantt-hours-long', { n: roundHours(entry.planned) })}
            thresholdLabel={
              entry.threshold && t('gantt-hours-short', { n: roundHours(entry.threshold.limit) })
            }
            deltaDecimals={CAPACITY_HOURS_DISPLAY_DECIMALS}
          />
        ))}
      </div>
      <DistributionLegend plannedLabel={t('gantt-planned')} availableLabel={t('gantt-required')} />
    </div>
  );
};
